<template>
    <div class="SitePreview">
        <div :style="'background-image: url(' + heroImageSrc + ');'"
             class="SitePreview__hero"
        >
            <span class="SitePreview__hero__overlay"></span>
            <div class="SitePreview__hero__headline"
                 :style="h1Style"
            >
                {{ heroHeadline }}
            </div>
            <div class="SitePreview__hero__subhead"
                 :style="subheadStyle"
            >
                {{ heroSubhead }}
            </div>
            <div class="SitePreview__button__wrap SitePreview__button__wrap--hero">
                        <span :style="buttonStyle + 'background-color: ' + color1 + ';'"
                              class="SitePreview__button"
                        >
                            {{ heroButtonText }}
                        </span>
            </div>
        </div>

        <div class="SitePreview__banner" :style="'background-color:' + color2 + ';' ">
            <div class="SitePreview__banner__item SitePreview__banner__item--item1" :style="bannerStyle">{{ banner1 }}</div>
            <div class="SitePreview__banner__item SitePreview__banner__item--item2" :style="bannerStyle">{{ banner2 }}</div>
            <div class="SitePreview__banner__item SitePreview__banner__item--item3" :style="bannerStyle">{{ banner3 }}</div>
        </div>

        <div class="SitePreview__body" :style="'background-color:' + color3 + ';' ">
            <div class="SitePreview__body__headshot">
                <div class="SitePreview__body__headshot__image-wrapper">
                    <img :src="headshotSrc" alt="" />
                </div>
            </div>
            <div class="SitePreview__body__content">
                <div class="SitePreview__body__headline"
                     :style="h2Style"
                >{{ bodyHeadline }}</div>
                <div class="SitePreview__body__copy"
                     :style="bodyStyle"
                >{{ bodyCopy }}</div>
                <div class="SitePreview__button__wrap SitePreview__button__wrap--body">
                            <span :style="buttonStyle + 'background-color: ' + color1 + ';'"
                                  class="SitePreview__button"
                            >
                                {{ bodyButtonText }}
                            </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from '@/store/store';
import { EventBus } from '@/store/eventBus';
import getElementCSS from '@/store/Modules/lib/getElementCSS';
export default {
    props: {
        fieldId: {
            type: String,
            required: true
        },

        fieldNamespace: {
            type: String,
            required: true
        }
    },

    computed: {
        /**
         * Colors
         */
        paletteId() {
            return store.state.websiteDesign.paletteId;
        },

        color1() {
            return store.state.websiteDesign.color1;
        },

        color2() {
            return store.state.websiteDesign.color2;
        },

        color3() {
            return store.state.websiteDesign.color3;
        },

        /**
         * Fonts
         */
        pairingId() {
            return store.state.websiteDesign.pairingId;
        },

        font1() {
            return store.state.websiteDesign.font1;
        },

        font2() {
            return store.state.websiteDesign.font2;
        },

        font1Size() {
            return store.state.websiteDesign.font1Size;
        },

        font2Size() {
            return store.state.websiteDesign.font2Size;
        },

        /**
         * Text
         */
        heroHeadline() {
            return store.state[this.fieldNamespace].options.preview.heroHeadline;
        },

        heroSubhead() {
            return store.state[this.fieldNamespace].options.preview.heroSubhead;
        },

        heroButtonText() {
            return store.state[this.fieldNamespace].options.preview.heroButtonText;
        },

        banner1() {
            return store.state[this.fieldNamespace].options.preview.banner1;
        },

        banner2() {
            return store.state[this.fieldNamespace].options.preview.banner2;
        },

        banner3() {
            return store.state[this.fieldNamespace].options.preview.banner3;
        },

        bodyHeadline() {
            return store.state[this.fieldNamespace].options.preview.bodyHeadline;
        },

        bodyCopy() {
            return store.state[this.fieldNamespace].options.preview.bodyCopy;
        },

        bodyButtonText() {
            return store.state[this.fieldNamespace].options.preview.bodyButtonText;
        },

        /**
         * Images
         */
        heroImageSrc() {
            return store.state[this.fieldNamespace].options.preview.heroImageSrc;
        },

        headshotSrc() {
            return store.state[this.fieldNamespace].options.preview.headshotSrc;
        }
    },

    data() {
        return {
            srcData: undefined,
            iframeLoading: true,
            h1Style: '',
            h2Style: '',
            bodyStyle: '',
            bannerStyle: '',
            buttonStyle: '',
            subheadStyle: '',
        };
    },

    mounted() {
        EventBus.$on('UserPreviewChange', (args) => this.setupPreview(args));
    },

    methods: {
        setupPreview(args) {
            this.setFontStyles(args);
            this.loadWebFonts();
        },

        loadWebFonts() {
            if (this.font1 && this.font2) {
                const fam = [this.font1, this.font2];

                window.WebFont.load({
                    google: {
                        families: fam
                    }
                });
            }
        },

        setFontStyles(args) {
            this.h1Style = getElementCSS('h1', args);
            this.h2Style = getElementCSS('h2', args);
            this.bodyStyle = getElementCSS('body', args);
            this.bannerStyle = getElementCSS('banner', args);
            this.buttonStyle = getElementCSS('button', args);
            this.subheadStyle = getElementCSS('subhead', args);
        },
    },
};
</script>

<style lang="scss">
    .SitePreview {
        display: flex;
        flex-flow: row wrap;
        flex: 0 0 100% !important;
        width: 100% !important;
        max-width: 100% !important;
        font-size: 16px;
        box-sizing: border-box;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.07) !important;
        border-radius: $border-radius-root;

        *, *:before, *:after {
            box-sizing: inherit;
        }
    }

    .SitePreview__hero {
        position: relative;
        z-index: 1;
        display: flex;
        flex-flow: row wrap;
        flex: 0 0 100%;
        width: 100%;
        padding: 2rem;
        color: white;
        font-size: 0.7rem;
        background-size: cover;
        background-position: center center;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;

        @media (min-width: 375px) {
            font-size: 0.9rem;
        }

        @media (min-width: 480px) {
            font-size: 1rem;
        }

        @media (min-width: 768px) {
            padding: 3rem;
        }

        @media (min-width: 1200px) {
            padding: 6rem 3rem;
        }
    }

    .SitePreview__hero__overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 2;
        background: rgb(0, 0, 0);
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.4289916650253851) 0%, rgba(0, 0, 0, 0) 100%);
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .SitePreview__hero__headline {
        position: relative;
        z-index: 3;
        flex: 0 0 100%;
        width: 100%;
        text-align: center;
        margin-bottom: 1rem;

        @media (min-width: 768px) {
            margin-bottom: 0.6rem;
        }
    }

    .SitePreview__hero__subhead {
        position: relative;
        z-index: 3;
        flex: 0 0 100%;
        width: 100%;
        margin-bottom: 1rem;
        text-align: center;

        @media (min-width: 768px) {
            margin-bottom: 2rem;
        }
    }

    .SitePreview__button__wrap {
        position: relative;
        z-index: 3;
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        flex: 0 0 100%;
        width: 100%;
    }

    .SitePreview__button__wrap--body {
        @media (min-width: 768px) {
            justify-content: flex-start;
        }
    }

    .SitePreview__button {
        display: flex;
        justify-content: center;
        flex: 0 1 auto;
        width: auto;
        text-align: center;
        color: white;
        padding: 12px;
        border-radius: 6px;
    }

    .SitePreview__banner {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-around;
        flex: 0 0 100%;
        width: 100%;
        color: white;
        font-size: 0.8rem;

        @media (min-width: 480px) {
            flex-flow: row nowrap;
            font-size: 1rem;
        }
    }

    .SitePreview__banner__item {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        align-content: center;
        align-items: center;
        padding: 0.9rem;
        text-align: center;
    }

    .SitePreview__banner__item--item1 {

    }

    .SitePreview__banner__item--item2 {
        padding-top: 0;
        padding-bottom: 0;

        @media (min-width: 768px) {
            padding: 0.9rem;
        }
    }

    .SitePreview__banner__item--item3 {

    }

    .SitePreview__body {
        display: flex;
        flex-flow: row wrap;
        flex: 0 0 100%;
        width: 100%;
        padding: 36px;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .SitePreview__body__headshot {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        flex: 0 0 100%;
        width: 100%;
        margin-bottom: 36px;

        img {
            width: 100%;
            height: auto;
        }

        @media (min-width: 480px) {
            padding: 12px 36px;
        }

        @media (min-width: 768px) {
            flex: 0 0 30%;
            width: 30%;
            padding: 0;
        }
    }

    .SitePreview__body__headshot__image-wrapper {
        flex: 0 0 100%;
        width: 100%;
        position: relative;
        padding-top: 100%;

        img {
            display: block;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            object-fit: cover;
            object-position: center;
        }
    }

    .SitePreview__body__content {
        @media (min-width: 768px) {
            flex: 0 0 70%;
            width: 70%;
            padding-left: 36px;
        }
    }

    .SitePreview__body__headline {
        margin-bottom: 24px;

        @media (min-width: 768px) {
            margin-bottom: 8px;
        }
    }

    .SitePreview__body__copy {
        margin-bottom: 36px;
    }

    .iframe__card {
        position: relative;
        z-index: 2;
        pointer-events: none;
        min-height: 600px;
    }

    .iframe__overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 3;
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        background-color: white;
        opacity: 1;
        transition: background-color 0.3s linear, opacity 0.3s linear;

        &.jsIframeLoaded {
            background-color: transparent;
            opacity: 0;
            transition: background-color 0.3s linear, opacity 0.3s linear;
        }
    }
</style>
